import routerOptions0 from "/usr/src/app/content/n3-spas-c3394ab9-2c54-457f-b894-d21b6756d75e/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}